export const NAVIGATE = 'navigate';
export const ITEM_CLICK = 'itemClick';


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/video-playlist/events.js
 **/